export default __webpack_public_path__ + "static/summer_containers80-e168de09dc9c9dfe0b7e7d78d997cfb4.webp";